import { Reveal, Eyebrow } from "./AmberCallout";

const About = () => (
  <section id="about" data-testid="about-section" className="py-20 sm:py-28 lg:py-32 scroll-mt-20">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10 lg:gap-16">
        <div className="md:col-span-4">
          <Reveal>
            <Eyebrow>About</Eyebrow>
            <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl tracking-tight text-ink leading-tight">
              Curious by nature, comfortable being a beginner.
            </h2>
          </Reveal>
        </div>
        <div className="md:col-span-7 md:col-start-6">
          <Reveal delay={0.1}>
            <p className="text-base sm:text-lg text-ink2 leading-relaxed">
              I&rsquo;ve taken a few unexpected turns: from German literature to psychology, and
              from Taiwan to studying in Germany and the UK. Each move meant learning a new way of
              thinking, a new academic system, or a new way to express myself. I used to think I
              had to feel fully prepared before trying something unfamiliar. I&rsquo;ve since
              learned that curiosity, and being willing to ask questions, usually gets me further.
            </p>
            <p className="mt-5 text-base sm:text-lg text-ink2 leading-relaxed">
              I enjoy picking up new ideas, listening to perspectives that challenge my own, and
              working out what I still need to learn. I&rsquo;m drawn to work that keeps me curious
              and gives me room to grow. My browser tabs on decision-making may be getting out of
              hand, but at least my interests are varied.
            </p>
            <p className="mt-5 text-base sm:text-lg text-ink2 leading-relaxed">
              Learning languages is one of the things I enjoy most, even when speaking a second
              language occasionally makes me feel like my brain has temporarily left the room. I
              speak Mandarin and English, have studied German, and am learning Korean. Each
              language has opened a different window onto how people think and express themselves,
              and I&rsquo;m happy to keep making mistakes along the way.
            </p>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);

export default About;
